.buttonReset {
  &[type='button'] {
    -webkit-appearance: none;
    appearance: none;
  }
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0;
  text-align: center;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;
}
